import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { AnnouncementText } from '../lib/api';
import './AnnouncementModal.css';

interface AnnouncementModalProps {
  isOpen: boolean;
  onClose: () => void;
  // 后台公告文案（按当前语言解析后）；为空时回退内置 i18n
  announcement?: AnnouncementText | null;
  fallbackAnn?: AnnouncementText | null;
}

const AnnouncementModal: React.FC<AnnouncementModalProps> = ({
  isOpen,
  onClose,
  announcement,
  fallbackAnn,
}) => {
  const { t } = useLanguage();

  if (!isOpen) return null;

  const fallbackSections = fallbackAnn?.sections?.length
    ? fallbackAnn.sections
    : [
        { title: t.announcement.section1Title, content: t.announcement.section1Content },
        { title: t.announcement.section2Title, content: t.announcement.section2Content },
        { title: t.announcement.section3Title, content: t.announcement.section3Content },
      ];
  const sections = announcement?.sections?.length ? announcement.sections : fallbackSections;

  return (
    <div className="announcement-modal-overlay" onClick={onClose}>
      <div className="announcement-modal" onClick={(e) => e.stopPropagation()}>
        <div className="announcement-modal-header">
          <h2>{announcement?.modalTitle || fallbackAnn?.modalTitle || t.announcement.modalTitle}</h2>
          <button className="announcement-modal-close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="announcement-modal-content">
          {sections.map((section, i) => (
            <div key={i} className="announcement-section">
              <h3>{section.title}</h3>
              <p>{section.content}</p>
            </div>
          ))}
        </div>
        <div className="announcement-modal-footer">
          <button className="announcement-modal-btn" onClick={onClose}>
            {t.announcement.closeBtn}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;